import React, { useEffect, useState } from "react";
import { useTimeout } from "hooks/useTimeout";
import Fade from "@material-ui/core/Fade";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import useStyles from "./styles";

export interface Props {
  children?: React.ReactNode;
  className?: string;
  startTimestamp: number;
  showCloseButton?: boolean;
}

const FlashMessage = ({
  startTimestamp,
  showCloseButton,
  children,
  className
}: Props) => {
  const classes = useStyles();
  const [show, setShow] = useState<boolean>(!!startTimestamp);
  const [timer, setTimer] = useState<number>(2000);
  const [shouldHide, setShouldHide] = useState(true);

  const handleMouseEnter = () => setShouldHide(false);
  const handleMouseLeave = () => setShouldHide(true);

  const handleClose = () => {
    setShouldHide(true);
    setTimer(0);
  };

  useEffect(() => {
    if (startTimestamp) {
      setShow(true);
    }
  }, [startTimestamp]);

  const hideBox = () => {
    if (shouldHide) {
      setShow(false);
      setTimer(2000);
    }
  };

  useTimeout(hideBox, timer);

  const renderCloseButton = () => {
    let output;

    if (showCloseButton) {
      output = (
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={classes.closeButton}
        >
          <CloseIcon className={classes.closeButtonIcon} />
        </IconButton>
      );
    }

    return output;
  };

  const closeButtonOutput = renderCloseButton();

  let attr = {
    timeout: {
      enter: 300,
      exit: 1000
    }
  };

  if (!shouldHide) {
    attr = null;
  }

  return (
    <Fade mountOnEnter unmountOnExit in={show} {...attr}>
      <Box
        className={className}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
        {closeButtonOutput}
      </Box>
    </Fade>
  );
};

export default FlashMessage;
